import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { UserLogin } from '../../../model/user';
import { UserByResetKeyActionTypes } from './types';

export const userByResetKeyRequest = (key: string) => action(UserByResetKeyActionTypes.USER_BY_RESET_KEY_REQUEST, key);
export const userByResetKeySuccess = (user: UserLogin) => action(UserByResetKeyActionTypes.USER_BY_RESET_KEY_SUCCESS, user);
export const userByResetKeyError = (error: GiroWebappError) => action(UserByResetKeyActionTypes.USER_BY_RESET_KEY_ERROR, error);
export const userByResetKeyResetState = () => action(UserByResetKeyActionTypes.USER_BY_RESET_KEY_RESET_STATE);
